export default __webpack_public_path__ + "static/media/3031 spice rack A side.22db6650.png";